import { z } from "zod";

import { configValueSchema } from "./configValue.ts";
import { refsSchema } from "./refsSchema.ts";
import { ValueConfigs } from "./valueConfig.ts";
import { variableConfigSchema } from "./variableConfigSchema.ts";

export const variableConfigsSchema = z.record(z.string(), variableConfigSchema);

export type VariableConfigs = z.infer<typeof variableConfigsSchema>;

export const nodeConfigSchema = z
  .object({
    variables: variableConfigsSchema.optional(),
    nodeReferences: refsSchema.optional(),
    values: ValueConfigs.optional(),
  })
  .and(z.record(z.string(), configValueSchema));

export type NodeConfig = z.infer<typeof nodeConfigSchema>;
